import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';

export const useInfoTabStyles = () => {
  return useStyles(({theme, mediaOnly}) => ({
    cardInfo: {
      ...mediaOnly(DeviceSize.mobile, {
        shadowColor: 'black',
        shadowOpacity: 0.5,
        shadowRadius: 10,
        paddingTop: 35,
        paddingHorizontal: 16,
        paddingBottom: 16,
      }),
    },
    title: {
      ...theme.fonts.h1,
      lineHeight: 40,
      color: theme.color.textColor,
    },
    subTitle: {
      ...theme.fonts.h3,
      color: theme.color.textColor,
      fontFamily: 'GothamPro',
      fontWeight: '600',
    },
    regNumber: {
      ...theme.fonts.h3,
      color: theme.color.textColor,
      fontFamily: 'GothamPro',
      fontWeight: '600',
      marginTop: 30,
    },
    topBlock: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 50,
      width: '100%',
    },
    topBlockLeftColumn: {
      maxWidth: '70%',
      height: '100%',
    },
    balanceCard: {
      shadowRadius: 10,
      shadowOpacity: 0.5,
      shadowColor: theme.color.shaddowBg,
      borderRadius: 14,
      backgroundColor: theme.color.whiteTextColor,
      paddingVertical: 20,
      paddingHorizontal: 46,
      flexShrink: 0,
      width: 'auto',
      height: 'auto',
    },
    balanceText: {
      ...theme.fonts.h4,
      fontSize: 20,
      lineHeight: 30,
      marginBottom: 18,
    },
    balance: {
      ...theme.fonts.h1,
      color: theme.color.primaryColor,
      whiteSpace: 'pre-wrap',
      overflowWrap: 'break-word',
    },
    organizationName: {
      ...theme.fonts.body,
      marginVertical: 40,
      color: theme.color.labelText,
    },
    truName: {
      ...theme.fonts.h5Light,
      color: theme.color.textColor,
      lineHeight: 45,
    },
  }));
};
